import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link, useResolvedPath, useMatch } from "react-router-dom";
import { CgMenuRight, CgClose } from "react-icons/cg";

import logo from "../../../Assets/logo.svg";
import "./styles.css";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const [workOpen, setWorkOpen] = useState(false);
  const [isMobileNav, setIsMobileNav] = useState(false);

  const digitalMatch = useMatch({ path: "/digital", end: true });
  const exploratoryMatch = useMatch({ path: "/experiential", end: true });
  const fmpMatch = useMatch({ path: "/fmp", end: true });
  const moreMatch = useMatch({ path: "/more", end: true });
  const isWorkActive =
    digitalMatch || exploratoryMatch || fmpMatch || moreMatch;

  useEffect(() => {
    const mobileQuery = window.matchMedia("(max-width: 940px)");
    const updateMobileNav = (event) => {
      setIsMobileNav(event.matches);
      setWorkOpen(event.matches && Boolean(isWorkActive));
    };

    updateMobileNav(mobileQuery);

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener("change", updateMobileNav);
      return () => mobileQuery.removeEventListener("change", updateMobileNav);
    }

    mobileQuery.addListener(updateMobileNav);
    return () => mobileQuery.removeListener(updateMobileNav);
  }, [isWorkActive]);

  const handleToggle = () => {
    window.scrollTo(0, 0);
    setToggle(!toggle);
    if (!toggle && isMobileNav && isWorkActive) setWorkOpen(true);
  };

  const variants = {
    hidden: { opacity: 0, y: 0 },
    visible: {
      opacity: 1,
      y: -10,
      transition: {
        duration: 0.5,
        type: "tween",
        when: "beforeChildren",
        staggerChildren: 0.1,
      },
    },
  };

  const scrollToTop = () => window.scrollTo(0, 0);

  const closeMenu = () => {
    scrollToTop();
    setToggle(false);
    setWorkOpen(false);
  };

  const toggleWorkMenu = () => {
    if (!isMobileNav) return;
    setWorkOpen((isOpen) => !isOpen);
  };

  return (
    <div className='navbar__container'>
      {/* LOGO */}

      <motion.div
        initial='hidden'
        animate='visible'
        variants={variants}
        className='navbar__logo'
      >
        <Link className='noLink' to='/'>
          <img
            onClick={() => {
              window.scrollTo(0, 0);
              setToggle(false);
            }}
            className='navbar__logoImg'
            alt=''
            src={logo}
          />
        </Link>
      </motion.div>

      <motion.div
        initial='hidden'
        animate='visible'
        variants={variants}
        className='navbar__menuIcon'
        onClick={handleToggle}
      >
        {toggle ? <CgClose /> : <CgMenuRight />}
      </motion.div>

      {/* MENU */}

      <motion.ul
        initial='hidden'
        animate='visible'
        variants={variants}
        className={
          toggle ? "showNav navbar__menuList" : "hideNav navbar__menuList"
        }
      >
        <motion.li onClick={handleToggle} variants={variants}>
          <NavLink onClick={scrollToTop} className='noLink' to='stories'>
            STORIES
          </NavLink>
        </motion.li>
        <motion.li
          variants={variants}
          className={
            workOpen
              ? "navbar__dropdown navbar__dropdown--open"
              : "navbar__dropdown"
          }
        >
          <button
            type='button'
            className='navbar__dropdownTrigger'
            aria-haspopup='true'
            aria-expanded={isMobileNav ? workOpen : false}
            onClick={toggleWorkMenu}
            style={{ fontWeight: isWorkActive ? "700" : "300" }}
          >
            DESIGN
          </button>
          <ul className='navbar__dropdownMenu' aria-label='Work categories'>
            <li>
              <NavLink
                onClick={closeMenu}
                className='noLink navbar__dropdownLink'
                to='digital'
              >
                DIGITAL
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={closeMenu}
                className='noLink navbar__dropdownLink'
                to='experiential'
              >
                EXPLORATORY
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={closeMenu}
                className='noLink navbar__dropdownLink'
                to='fmp'
              >
                FMP
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={closeMenu}
                className='noLink navbar__dropdownLink'
                to='more'
              >
                MORE
              </NavLink>
            </li>
          </ul>
        </motion.li>

        <motion.li onClick={handleToggle} variants={variants}>
          <NavLink onClick={scrollToTop} className='noLink' to='notebook'>
            NOTEBOOK
          </NavLink>
        </motion.li>
        <motion.li onClick={handleToggle} variants={variants}>
          <NavLink onClick={scrollToTop} className='noLink' to='about'>
            ABOUT
          </NavLink>
        </motion.li>
        <motion.li
          onClick={handleToggle}
          variants={variants}
          className='navbar__contactBtn'
        >
          <a
            onClick={scrollToTop}
            className='noLink'
            href='mailto:storiesbymoubani@gmail.com'
          >
            CONTACT ME
          </a>
        </motion.li>
      </motion.ul>
    </div>
  );
};

export default Navbar;

const NavLink = ({ children, to, ...props }) => {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: resolved.pathname, end: true });

  return (
    <Link style={{ fontWeight: match ? "700" : "300" }} to={to} {...props}>
      {children}
    </Link>
  );
};
